module.exports = __webpack_public_path__ + "ov_11.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/contact/ov/ov_11.jpg
// module id = 871
// module chunks = 0